import { data } from '../../svg/Stack/data';
import { makeIcon } from '../makeIcon';

export const Stack = makeIcon(data, 'table_rows_narrow', 'Stack');

export default Stack;
